<a [href]="href" [class]="class"
  ><span class="font-weight-bolder" onclick="return false;">{{ label }}</span></a
>
